export enum TemplateLinkTooltips {
  downloadPoster = 'Download Poster',
  edit = 'Edit',
  archive = 'Archive',
  restore = 'Restore',
}
